import React, { ReactNode } from "react";
import { Fragment } from "react";
import {
  Dialog,
  DialogPanel,
  Transition,
  TransitionChild,
} from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { useConfiguration } from "../configuration";

export interface ModalProps {
  open?: boolean;
  children: ReactNode;
  onClose: () => any;
}

export default function Example({ open, onClose, children }: ModalProps) {
  const { mlrVersion } = useConfiguration();

  return (
    <Transition show={open} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onClose}>
        <TransitionChild
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </TransitionChild>

        <div className="fixed inset-0 z-50 w-screen overflow-y-auto">
          <div className="flex flex-col min-h-full items-end justify-center p-4 text-center sm:items-center lg:p-0">
            <TransitionChild
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <DialogPanel className="relative inline-block sm:align-middle bg-white rounded-lg px-12 pt-24 pb-20 md:pb-24 md:px-28 text-left overflow-hidden shadow-xl transform transition-all w-full max-w-2xl sm:my-8 opacity-100 translate-y-0 sm:scale-100">
                <div className="absolute top-0 right-0 pt-8 lg:pr-8 pr-6 print:hidden">
                  <button
                    type="button"
                    className="rounded-md bg-survey-brand text-font-contrast hover:bg-survey-hover"
                    onClick={onClose}
                  >
                    <span className="sr-only">Close</span>
                    <XMarkIcon className="h-11 w-11" aria-hidden="true" />
                  </button>
                </div>
                <div className="flex items-start flex-col">
                  <>
                    {children}
                    {!!mlrVersion && (
                      <div className="w-full flex justify-end">
                        <span className="text-xs whitespace-pre">{mlrVersion}</span>
                      </div>
                    )}
                  </>
                </div>
              </DialogPanel>
            </TransitionChild>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
